import React from 'react';

const IconArrowButton = ({ isPrev = false }) => {
    if (isPrev)
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={52} height={52} viewBox="0 0 52 52" fill="none">
                <circle cx={26} cy={26} r="24.5" fill="white" stroke="#CECED4" strokeWidth={3} />
                <path
                    d="M29.9395 14.9697L18.1213 25.1246L29.9395 37.0303"
                    stroke="#CECED4"
                    strokeWidth={4}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={52} height={52} viewBox="0 0 52 52" fill="none">
            <circle
                cx={26}
                cy={26}
                r="24.5"
                transform="matrix(-1 0 0 1 52 0)"
                fill="white"
                stroke="#CECED4"
                strokeWidth={3}
            />
            <path
                d="M22.0605 14.9697L33.8787 25.1246L22.0605 37.0303"
                stroke="#CECED4"
                strokeWidth={4}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default IconArrowButton;
